import React from 'react'
import style from "./Map.module.css"
import { useMemo } from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';


export default function Map() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  });
  if (!isLoaded) return <div>Loading</div>
  return <Gmap />;
}


function Gmap() {
  const center = useMemo(() => ({ lat: 41.34722447224354, lng: 69.2793119344248 }), []);


  return <GoogleMap zoom={15} center={center} mapContainerClassName="map-container" >
    <Marker position={{ lat: 41.34722447224354, lng: 69.2793119344248 }} color="yellow"/>z
  </GoogleMap>
}

